<template>
  <div class="designCoordination">
    <el-card>
      <div slot="header" class="clearfix">
        <!-- 标题 -->
        <span style="font-size: 24px">安全交底</span>
        <div class="head-text" style="float: right; margin-top: -4px">
          <!-- 新建事件 -->
          <el-input
            placeholder="请输入项目名称"
            style="width: 200px"
            class="search-input"
            v-model="query"
          ></el-input>
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="getData"
            style="margin-right: 80px"
          ></el-button>
          <el-button
            v-if="
              ($store.state.permissions != null &&
                $store.state.permissions.includes('40101')) ||
              $store.state.isProject
            "
            type="primary"
            @click="addDialogFormVisibleOpen"
            >新建</el-button
          >
        </div>
      </div>

      <div class="rygl-table">
        <el-table
          align="center"
          class="margin-20 table"
          v-loading="loading"
          :data="userList"
          height="72vh"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            align="center"
            type="selection"
            width="55"
          ></el-table-column>
          <!-- <el-table-column align="center" class="ss" prop="id" label="ID" width="80"></el-table-column> -->
          <el-table-column align="center" prop="pjsf04" label="项目名称">
            <template slot-scope="scope">
              <el-button
                :title="scope.row.pjsf04"
                style="width: 100%"
                @click="seeListInfo(scope.row)"
                >{{
                  scope.row.pjsf04.length > 5
                    ? scope.row.pjsf04.substr(0, 5) + "..."
                    : scope.row.pjsf04
                }}</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="pjsf03"
            label="文件编号"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="pjsf05"
            label="主题"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="pjsf10"
            label="专业"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="pjsf06"
            label="负责人"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="Name"
            label="创建者"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="pjsf15"
            label="提交单位"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="pjsf16"
            label="创建日期"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="pjsf17"
            label="完成时间"
          ></el-table-column>
          <el-table-column align="center" prop="Address" label="状态">
            <template slot-scope="scope">
              <p v-if="scope.row.pjsf17 == null" style="color: red">审批中</p>
              <p v-else style="color: green">已完成</p>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button
                size="small"
                type="primary"
                plain
                @click="Exports(scope.row)"
                >打印</el-button
              >
              <el-button
                v-if="scope.row.state == 1 && scope.row.pjsf17 == null"
                size="small"
                type="primary"
                plain
                @click="HandeApprovalOpen(scope.row)"
                >审批</el-button
              >
              <el-button
                v-if="
                  ($store.state.permissions != null &&
                    $store.state.permissions.includes('40102')) ||
                  $store.state.isProject
                "
                size="small"
                type="danger"
                plain
                @click="DelProjectSafe(scope.row)"
                >撤销</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        style="margin-top: 20px"
        align="center"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagenum"
        :page-sizes="[10, 50, 100]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
    <!-- 这里是新建 -->
    <el-dialog
      :close-on-click-modal="false"
      title="安全交底"
      :visible.sync="addDialogFormVisible"
      width="60%"
      center
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        style="width: 97%"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="项目编号" prop="pjsf03">
          <el-input v-model="ruleForm.pjsf03"></el-input>
        </el-form-item>
        <el-form-item label="项目名称" prop="pjsf04">
          <el-input v-model="ruleForm.pjsf04"></el-input>
        </el-form-item>
        <el-form-item label="主题" prop="pjsf05">
          <el-input v-model="ruleForm.pjsf05"></el-input>
        </el-form-item>
        <el-form-item label="负责人" prop="pjsf06">
          <el-input v-model="ruleForm.pjsf06"></el-input>
        </el-form-item>
        <el-form-item label="负责单位" prop="pjsf07">
          <el-input v-model="ruleForm.pjsf07"></el-input>
        </el-form-item>
        <el-form-item label="危险等级" prop="pjsf07">
          <el-input v-model="ruleForm.pjsf08"></el-input>
        </el-form-item>
        <el-form-item label="危险源" prop="pjsf07">
          <el-input v-model="ruleForm.pjsf09"></el-input>
        </el-form-item>
        <el-form-item label="提交单位" prop="pjsf07">
          <el-input v-model="ruleForm.pjsf15"></el-input>
        </el-form-item>
        <el-form-item label="专业" prop="pjsf07">
          <el-checkbox-group v-model="ruleForm.pjsf10">
            <el-checkbox
              :label="item.lbst03"
              v-for="item in zyList"
              :key="item.lbst01"
            ></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="问题标签" prop="pjsf07">
          <el-checkbox-group v-model="ruleForm.pjsf11">
            <el-checkbox
              :label="item.lbst03"
              v-for="item in wtList"
              :key="item.lbst01"
            ></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="位置" prop="pjsf07">
          <el-checkbox-group v-model="ruleForm.pjsf12">
            <el-checkbox
              :label="item.lbst03"
              v-for="item in wzList"
              :key="item.lbst01"
            ></el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="内容" prop="pjsf07">
          <el-input type="textarea" v-model="ruleForm.pjsf13"></el-input>
        </el-form-item>
        <el-form-item label="关联模型">
          <el-button size="small" type="primary" plain @click="modelChooseList"
            >关联模型</el-button
          >
          <el-row
            v-show="TypeData.length"
            style="max-height: 200px; overflow: auto"
          >
            <el-col span="12" v-for="(item, index) in TypeData" :key="index">
              <el-row>
                <el-col :span="20" :title="item.name">{{
                  item.name.length > 15
                    ? item.name.substr(0, 15) + "..."
                    : item.name
                }}</el-col>
                <el-col :span="4">
                  <el-button
                    type="danger"
                    size="mini"
                    plain
                    @click="deleteGetModelSelectList2Item(index)"
                    >删除</el-button
                  >
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item label="关联资料">
          <el-button
            size="small"
            type="primary"
            plain
            @click="associatedDataOpen"
            >关联资料</el-button
          >
          <el-row
            v-show="GetFilesLinksList2.length"
            style="max-height: 200px; overflow: auto"
          >
            <el-col
              span="12"
              v-for="(item, index) in GetFilesLinksList2"
              :key="index"
            >
              <el-row>
                <el-col :span="20" :title="item.prfl02">{{
                  item.prfl02.length > 15
                    ? item.prfl02.substr(0, 15) + "..."
                    : item.prfl02
                }}</el-col>
                <el-col :span="4">
                  <el-button
                    type="danger"
                    size="mini"
                    plain
                    @click="deletemultipleSelection2(index)"
                    >删除</el-button
                  >
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 这里是模型选择集 -->
    <el-dialog
      :close-on-click-modal="false"
      title="关联模型"
      :visible.sync="modelChooseListOpen"
      width="60%"
      center
    >
      <el-row>
        <el-col :span="6" v-for="(item, index) in TypeData" :key="index">
          <el-row>
            <el-col :span="16" :title="item.name">
              <p>
                {{
                  item.name.length > 5
                    ? item.name.substr(0, 5) + "..."
                    : item.name
                }}
              </p>
            </el-col>
            <el-col :span="8">
              <el-button
                style="position: relative; top: -4px"
                type="danger"
                plain
                size="mini"
                @click="deleteGetModelSelectList2Item(index)"
                >删除</el-button
              >
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <!-- 11 -->
      <el-container>
        <el-aside
          width="200px"
          style="
            border: 1px solid #dcdfe6;
            border-radius: 4px;
            height: 100%;
            text-align: center;
          "
          class="elAside"
        >
          <div class="zTreeDiv">
            <ul id="WorkPlaneTree" class="ztree"></ul>
          </div>
        </el-aside>
        <el-main>
          <el-row>
            <el-col :span="4">
              <el-select
                filterable
                v-model="TypeName"
                @change="TypehandleClick"
                title="请选择类型"
                placeholder="请选择类型"
              >
                <el-option key="1" label="选择集" value="1"></el-option>
                <el-option key="2" label="视点" value="3"></el-option>
              </el-select>
            </el-col>
            <el-col :span="11">
              <div class="head-text">
                <!-- 新建事件 -->
                <el-input
                  placeholder="输入关键字"
                  style="width: 250px"
                  class="search-input"
                  v-model="query2"
                ></el-input>
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="aa"
                ></el-button>
              </div>
            </el-col>
          </el-row>

          <el-table
            ref="multipleTable"
            :data="GetModelSelectList"
            tooltip-effect="dark"
            style="width: 100%"
            height="550px"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="name" label="名字"></el-table-column>
          </el-table>

          <el-row>
            <el-col :span="3" :offset="9">
              <el-button
                type="primary"
                style="margin-left: 10px"
                @click="modelChooseListClose"
                >确定</el-button
              >
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </el-dialog>

    <!-- 关联资料 -->
    <el-dialog
      :close-on-click-modal="false"
      title="关联资料"
      :visible.sync="associatedData"
      width="80%"
      top="100px"
      center
    >
      <el-row>
        <el-col
          :span="4"
          v-for="(item, index) in GetFilesLinksList2"
          :key="index"
        >
          <el-row>
            <el-col :span="16" :title="item.prfl02">{{
              item.prfl02.length > 8
                ? item.prfl02.substr(0, 8) + "..."
                : item.prfl02
            }}</el-col>
            <el-col :span="4">
              <el-button
                style="position: relative; top: -4px"
                size="small"
                @click="deleteGetFilesLinksList2Item(index)"
                type="danger"
                plain
                >删除</el-button
              >
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-container>
        <el-aside width="200px" style="text-align: center">
          <!-- <el-tree :data="TreeData" :props="defaultProps" @node-click="handleNodeClick">
            <span slot-scope="{ node, data }">
              <span>{{ node.label }} ({{data.Count}})</span>
            </span>
          </el-tree>-->
          <el-button type="primary" size="small" @click="showAll"
            >显示全部文件</el-button
          >
          <div class="zTreeDiv">
            <ul id="ProjectFileTree" class="ztree"></ul>
          </div>
          <div
            id="dataListRemenu"
            v-if="
              ($store.state.permissions != null &&
                $store.state.permissions.includes('701')) ||
              $store.state.isProject
            "
          >
            <ul>
              <li id="addDataList">新增资料</li>
            </ul>
          </div>
        </el-aside>
        <el-main>
          <div class="head-text" style="float: right; margin-top: -4px">
            <!-- 新建事件 -->
            <el-input
              placeholder="请输入关键字"
              style="width: 200px"
              class="search-input"
              v-model="query3"
            ></el-input>
            <el-button
              slot="append"
              icon="el-icon-search"
              style="margin-right: 80px"
              @click="bb"
            ></el-button>
          </div>
          <el-table
            height="500"
            ref="multipleTable"
            :data="GetFilesLinksList"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange2"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="prfl02" label="名字"></el-table-column>
          </el-table>
          <el-row>
            <el-col :span="3" :offset="8">
              <el-button type="success" @click="associatedData = false"
                >确定关联</el-button
              >
            </el-col>
            <el-col :span="3">
              <el-button type="danger" @click="associatedDataClose"
                >取消</el-button
              >
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </el-dialog>
    <!-- 打印目标 -->
    <div id="pdfDom">
      <p
        style="
          text-align: center;
          font-size: 42px;
          font-weight: 600;
          margin: 20px 0;
        "
      >
        安全交底
      </p>
      <table border="2" class="tableContent">
        <tr>
          <td>项目编号</td>
          <td>{{ designForm.pjsf03 }}</td>
          <td>项目名称</td>
          <td>{{ designForm.pjsf04 }}</td>
        </tr>
        <tr>
          <td>主题</td>
          <td>{{ designForm.pjsf05 }}</td>
          <td>负责人</td>
          <td>{{ designForm.pjsf06 }}</td>
        </tr>
        <tr>
          <td>负责单位</td>
          <td colspan="3">{{ designForm.pjsf07 }}</td>
        </tr>
        <tr>
          <td colspan="4">
            <p style="text-align: center; padding: 10px">内容</p>
          </td>
        </tr>
        <tr>
          <td
            colspan="4"
            style="
              line-height: 60px;
              height: 100%;
              overflow: hidden;
              padding: 20px 50px;
            "
          >
            {{ designForm.pjsf13 }}
          </td>
        </tr>

        <tr>
          <td>专业标签</td>
          <td colspan="3">
            <i
              v-for="(item, index) in designForm.pjsf10"
              :key="index"
              style="margin: 0 10px"
              >{{ item }}</i
            >
          </td>
        </tr>
        <tr>
          <td>问题标签</td>
          <td colspan="3">
            <i
              v-for="(item, index) in designForm.pjsf11"
              :key="index"
              style="margin: 0 10px"
              >{{ item }}</i
            >
          </td>
        </tr>
        <tr>
          <td>位置标签</td>
          <td colspan="3">
            <i
              v-for="(item, index) in designForm.pjsf12"
              :key="index"
              style="margin: 0 10px"
              >{{ item }}</i
            >
          </td>
        </tr>

        <tr>
          <td>模型关联</td>
          <td colspan="3">
            <div
              style="
                float: left;
                width: 48%;
                margin: 10px;
                border: 1px solid #808080;
              "
              v-for="(item, index) in modelList"
              :key="index"
            >
              <img :src="$store.state.baseUrl + item.pic" width="100%" />
              <p style="text-align: center">{{ item.name }}</p>
            </div>
          </td>
        </tr>
        <tr>
          <td>关联资料</td>
          <td colspan="3">
            <i v-for="(item, index) in fileList" :key="index">{{
              item.prfl02
            }}</i>
          </td>
        </tr>

        <tr>
          <td colspan="4">
            <span style="border: none; font-weight: 600">审批流程：</span>
            <div>
              <div v-for="(gitem, gindex) in groupType" :key="gindex">
                <div
                  style="margin: 30px 15px; float: left"
                  v-for="(item, index) in auList"
                  :key="index"
                >
                  <div v-if="gitem == item.GroupType">
                    <div
                      :style="`margin-left:15px;border-radius:50%;width:80px;height:80px;background:url(${
                        $store.state.baseUrl + item.image
                      });background-repeat:no-repeat;background-size: 100%;`"
                    ></div>
                    <p style="text-align: center; margin-bottom: 10px">
                      {{ item.Name }}
                    </p>
                    <p
                      style="text-align: center; color: green"
                      v-if="item.State"
                    >
                      (已审批)
                    </p>
                    <p style="text-align: center; color: red" v-else>
                      (未审批)
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="4">
            <span style="border: none; font-weight: 600; margin-bottom: 20px"
              >抄送流程：</span
            >
            <div v-for="(item, index) in ccList" :key="index">
              <div
                :style="`margin-left:15px;border-radius:50%;width:80px;height:80px;background:url(${
                  $store.state.baseUrl + item.image
                });background-repeat:no-repeat;background-size: 100%;`"
              ></div>
              <p style="margin: 10px">{{ item.Name }}</p>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="4">
            <span style="border: none; font-weight: 600; margin-bottom: 20px"
              >审批意见：</span
            >
            <div
              style="
                margin: 0 auto;
                padding: 30px 0;
                font-size: 32px;
                line-height: 45px;
                border-radius: 10px;
              "
              v-for="(item, index) in auList"
              :key="index"
            >
              {{ item.Name }}：{{ item.Content }}
              <i style="float: right">{{ item.Time }}</i>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <!-- 查看详情 -->
    <el-dialog
      :close-on-click-modal="false"
      title="查看详情"
      :visible.sync="seeListInfoOpen"
      top="2%"
      width="80%"
      center
    >
      <el-row>
        <el-col :span="11">
          <el-form ref="FormData" :model="FormData" label-width="80px">
            <el-form-item label="项目编号" prop="pjsf03">
              <el-input v-model="FormData.pjsf03" disabled></el-input>
            </el-form-item>
            <el-form-item label="项目名称" prop="pjsf04">
              <el-input v-model="FormData.pjsf04" disabled></el-input>
            </el-form-item>
            <el-form-item label="主题" prop="pjsf05">
              <el-input v-model="FormData.pjsf05" disabled></el-input>
            </el-form-item>
            <el-form-item label="负责人" prop="pjsf06">
              <el-input v-model="FormData.pjsf06" disabled></el-input>
            </el-form-item>
            <el-form-item label="负责单位" prop="pjsf07">
              <el-input v-model="FormData.pjsf07" disabled></el-input>
            </el-form-item>
            <el-form-item label="专业" prop="dscd07">
              <el-checkbox-group v-model="zyList2">
                <el-checkbox
                  :label="item"
                  v-for="item in FormData.pjsf10"
                  :key="item.lbst01"
                  disabled
                ></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="问题标签" prop="dscd07">
              <el-checkbox-group v-model="wtList2">
                <el-checkbox
                  :label="item"
                  v-for="item in FormData.pjsf11"
                  :key="item.lbst01"
                  disabled
                ></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="位置" prop="dscd09">
              <el-checkbox-group v-model="wzList2">
                <el-checkbox
                  :label="item"
                  v-for="item in FormData.pjsf12"
                  :key="item.lbst01"
                  disabled
                ></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="内容" prop="dscd10">
              <el-input
                type="textarea"
                autosize
                v-model="FormData.pjsf13"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="模型关联">
              <el-table
                :data="modelList"
                max-height="200"
                style="width: 100%"
                border
              >
                <el-table-column
                  type="index"
                  width="55"
                  label="序号"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="name"
                  label="名称"
                  align="center"
                ></el-table-column>
                <el-table-column label="类型" align="center">
                  <template slot-scope="scope">{{
                    scope.row.type == 1 ? "选择集" : "视点"
                  }}</template>
                </el-table-column>
                <el-table-column label="截图" align="center">
                  <template slot-scope="scope">
                    <img
                      :src="$store.state.baseUrl + scope.row.pic"
                      v-if="scope.row.pic != null"
                      width="90px"
                    />
                  </template>
                </el-table-column>
                <el-table-column label="查看" align="center">
                  <template slot-scope="scope">
                    <el-button
                      type="primary"
                      size="small"
                      @click="viewModel(scope.row)"
                      >查看</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
            <el-form-item label="关联资料">
              <span style="color: red">点击按钮切换资料</span>
              <el-row>
                <el-col :span="12">
                  <el-row style="max-height: 400px; overflow: auto">
                    <el-col
                      :span="24"
                      v-for="(item, index) in fileList"
                      :key="index"
                    >
                      <el-button
                        style="width: 90%; margin: 10px"
                        @click="barCodeInit(item)"
                        size="small"
                        >{{ item.prfl02 }}</el-button
                      >
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="12">
                  <div id="codeShow" style="margin: 50px"></div>
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="11" :offset="1">
          <el-form ref="designForm" label-width="80px">
            <el-form-item label="审批流程">
              <el-card shadow="never" style="border: 1px solid #c0c4cc">
                <el-row v-for="(gitem, gindex) in groupType" :key="gindex">
                  <div
                    style="
                      overflow: hidden;
                      margin: 10px 0;
                      box-sizing: border-box;
                      border: 1px solid #eee;
                    "
                  >
                    <el-col
                      style="width: 60px; margin: 0 10px"
                      :span="2"
                      v-for="(item, index) in auList"
                      :key="index"
                    >
                      <div v-if="gitem == item.GroupType">
                        <div>
                          <el-avatar
                            size="large"
                            style="display: block; margin: 0 auto"
                            :src="$store.state.baseUrl + item.image"
                          ></el-avatar>
                        </div>
                        <p
                          style="
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            text-align: center;
                          "
                        >
                          {{ item.Name }}
                        </p>
                        <p
                          v-if="item.State"
                          style="color: green; text-align: center"
                        >
                          已审批
                        </p>
                        <p v-else style="color: red; text-align: center">
                          未审批
                        </p>
                        <p style="text-align: center">
                          {{ item.Type == 1 ? "或签" : "会签" }}
                        </p>
                      </div>
                    </el-col>
                  </div>
                </el-row>
              </el-card>
            </el-form-item>
            <el-form-item label="抄送流程">
              <el-card shadow="never" style="border: 1px solid #c0c4cc">
                <el-row>
                  <el-col
                    :span="2"
                    v-for="(item, index) in ccList"
                    :key="index"
                  >
                    <div>
                      <el-avatar
                        size="large"
                        :src="$store.state.baseUrl + item.image"
                      ></el-avatar>
                    </div>
                    <p style="text-align: center">{{ item.Name }}</p>
                  </el-col>
                  <el-col
                    :span="2"
                    v-for="(item, index) in ccList"
                    :key="index"
                  >
                    <div>
                      <el-avatar
                        size="large"
                        :src="$store.state.baseUrl + item.image"
                      ></el-avatar>
                    </div>
                    <p style="text-align: center">{{ item.Name }}</p>
                  </el-col>
                  <el-col
                    :span="2"
                    v-for="(item, index) in ccList"
                    :key="index"
                  >
                    <div>
                      <el-avatar
                        size="large"
                        :src="$store.state.baseUrl + item.image"
                      ></el-avatar>
                    </div>
                    <p style="text-align: center">{{ item.Name }}</p>
                  </el-col>
                </el-row>
              </el-card>
            </el-form-item>
            <el-form-item label="审批意见">
              <el-card
                shadow="never"
                style="
                  border: 1px solid #c0c4cc;
                  height: 100px;
                  margin: 10px 0;
                  padding: 10px;
                  font-size: 15px;
                  line-height: 25px;
                  background: #fff;
                "
                :v-if="item.Content !== null"
                v-for="(item, index) in auList"
                :key="index"
                disabled
                >{{ item.Name }} {{ item.Time }}：{{ item.Content }}</el-card
              >
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 新增 -->
    <el-dialog
      :close-on-click-modal="false"
      title="新增资料"
      :visible.sync="dialogVisible"
      width="40%"
    >
      <el-row>
        <el-col :span="12">
          <el-upload
            class="upload-demo"
            ref="upload"
            :action="actionUrl"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-upload="handleBefore"
            :file-list="fileList"
            :auto-upload="false"
            :data="aaa"
            :headers="importHeaders"
            :on-success="handleSuccess"
          >
            <el-button slot="trigger" size="small" type="primary"
              >选取文件</el-button
            >
          </el-upload>
        </el-col>
        <el-col :span="12">
          可见设置：
          <el-radio v-model="radio" :label="1">公开</el-radio>
          <el-radio v-model="radio" :label="2">半公开</el-radio>
          <div
            style="
              border: 2px solid #eee;
              height: 200px;
              max-height: 200px;
              overflow: auto;
              width: 80%;
              box-sizing: border-box;
            "
            v-if="radio == 2"
          >
            <el-row style="padding: 10px">
              <el-col
                :span="8"
                v-for="(item, index) in multipleSelection3"
                :key="index"
                style="padding-top: 10px"
              >
                <el-row style="padding: 0px">
                  <el-col :span="20">{{ item.user04 }}</el-col>
                  <el-col :span="4">
                    <span
                      style="color: red; cursor: pointer"
                      @click="delectUser(index)"
                      >x</span
                    >
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
          <el-button
            type="primary"
            size="small"
            style="margin: 10px"
            v-if="radio == 2"
            @click="dialogVisible1OPen"
            >添加</el-button
          >
        </el-col>
      </el-row>
      <el-row style="height: 80px">
        <el-col :span="3" :offset="8">
          <el-button type="primary" style="width: 100%" @click="submitUpload"
            >上传</el-button
          >
        </el-col>
        <el-col :span="3" :offset="1">
          <el-button
            type="primary"
            style="width: 100%"
            @click="dialogVisible = false"
            >取消</el-button
          >
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 项目下的人员列表 -->
    <el-dialog
      :close-on-click-modal="false"
      title="请选择人员"
      :visible.sync="dialogVisible1"
      width="25%"
    >
      <div class="head-text">
        <!-- 新建事件 -->
        <el-input
          v-model="selectName"
          placeholder="请输入名称"
          class="search-input"
          style="width: 80%"
        ></el-input>
        <el-button
          @click="dialogVisible1OPen"
          slot="append"
          icon="el-icon-search"
        ></el-button>
      </div>
      <el-table
        ref="multipleTable"
        :data="tableData3"
        tooltip-effect="dark"
        style="width: 100%"
        max-height="400"
        @selection-change="handleSelectionChange3"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          width="100"
        ></el-table-column>
        <el-table-column prop="user02" label="帐号"></el-table-column>
        <el-table-column prop="user04" label="姓名"></el-table-column>
      </el-table>
      <div
        style="width: 100%; height: 40px; margin-top: 10px; text-align: center"
      >
        <el-button type="primary" size="small" @click="dialogVisible1 = false"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "@/lib/asyncFZ";
// excel导出
import FileSaver from "file-saver";
import XLSX from "xlsx";
import {
  AddCorporateGovernanceRen,
  SwitchsCorporateGovernance,
  GetCorporateGovernanceDepartment,
  UpdateCorporateGovernanceDepartment,
  UpdateCorporateGovernancePosition,
  InviteCorporateGovernanceUser,
  RemoveCorporateGovernanceUser,
  GetUserInfo,
  GetProjectList,
  AddCompanyUser,
  GetDesigncdnationList,
  GetLablesetListOpen,
  GetProjectModelList,
  GetModelSelect,
  GetProjectFileZTree,
  GetFilesLinks,
  GetDesigncdnation,
  HandeApproval,
  GetLabelList,
  GetProjectSafeList,
  AddProjectSafe,
  HandelSafe,
  GetProjectSafeInfo,
  DelProjectSafe,
  GetProjectWorkInfo,
  DelProjectWork,
  GetModelSelectOrViewPoint,
  GetSelectOrView,
  GetFileWhitOutUserList,
  GetWorkPlaneTree2,
  FindWorkPlaneModel,
} from "@/setAxios.js";
export default {
  name: "designCoordination",
  data() {
    return {
      mid: 0,
      pid: -1,
      options: [],
      fid: 0,
      selectName: "",
      TypeData: [],
      TypeName: "1",
      tableData3: [],
      dialogVisible1: false,
      radio: "",
      actionUrl: this.$store.state.baseUrl + "/api/UploadDataFile",
      isClick: false,
      aaa: {
        uid: localStorage.getItem("id"),
        Uids: "",
        xid: localStorage.getItem("xid"),
        type: 1,
        gid: 0,
        qid: localStorage.getItem("pid"),
      },
      importHeaders: { token: localStorage.getItem("token") },
      fileList2: [],
      dialogVisible: false,
      designForm: [],
      modelList: [],
      fileList: [],
      auList: [],
      ccList: [],
      seeListInfoOpen: false,
      // tree配置
      defaultProps: {
        children: "children",
        label: "label",
      },
      TreeData: [],
      mid: "",
      modelName: "",
      GetModelSelectList: [],
      GetModelSelectList2: [],
      GetFilesLinksList: [],
      GetFilesLinksList2: [],
      loading: false,
      associatedData: false,
      obligation: {},
      userList: [],
      userList2: [],
      inviteList: [
        {
          CompanyId: localStorage.getItem("pid"),
        },
      ],
      qyList: [],
      addList: {},
      query: "",
      query2: "",
      query3: "",
      total: 0,
      pagesize: 10,
      pagenum: 1,
      btnShow: true,
      seeDialogFormVisible1: false,
      addDialogFormVisible: false,
      multipleSelection: [],
      multipleSelection2: [],
      multipleSelection3: [],
      editForm: {},
      addForm: {},
      rules2: {
        user02: [{ required: true, message: "请输入账号", trigger: "blur" }],
        user03: [{ required: true, message: "请选择密码", trigger: "blur" }],
        user04: [{ required: true, message: "请选择姓名", trigger: "blur" }],
        user05: [{ required: true, message: "请输入性别", trigger: "blur" }],
        user06: [
          { required: true, message: "请输入出生年月", trigger: "blur" },
        ],
        user10: [{ required: true, message: "请输入地址", trigger: "blur" }],
        user15: [
          { required: true, message: "请选择创建日期", trigger: "blur" },
        ],
      },
      deptList: {},
      deptList2: {},
      ruleForm: {
        pjsf02: localStorage.getItem("xid"),
        pjsf03: localStorage.getItem("XmBh"),
        pjsf04: localStorage.getItem("XmName"),
        pjsf05: null,
        pjsf06: null,
        pjsf07: null,
        pjsf08: null,
        pjsf09: null,
        pjsf10: [],
        pjsf11: [],
        pjsf12: [],
        ModelSelectIds: [],
        FileIds: [],
        pjsf13: null,
        pjsf14: localStorage.getItem("id"),
        pjsf15: null,
        pjsf16: new Date(),
        pjsf17: null,
      },
      rules: {
        pjsf03: [
          { required: true, message: "请输入项目编号", trigger: "blur" },
          // { min: 3, max: 8, message: "长度在 3 到 8 个字符", trigger: "blur" }
        ],
        pjsf04: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
          // { min: 3, max: 8, message: "长度在 3 到 8 个字符", trigger: "blur" }
        ],
        pjsf05: [
          { required: true, message: "请输入主题名称", trigger: "blur" },
          // { min: 3, max: 8, message: "长度在 3 到 8 个字符", trigger: "blur" }
        ],
        pjsf06: [
          { required: true, message: "请输入负责人", trigger: "blur" },
          // { min: 2, max: 8, message: "长度在 3 到 8 个字符", trigger: "blur" }
        ],
        pjsf07: [
          { required: true, message: "请输入内容", trigger: "blur" },
          // { min: 3, max: 20, message: "长度在 3 到 20 个字符", trigger: "blur" }
        ],
        dscd10: [
          { required: true, message: "请填写活动形式", trigger: "blur" },
        ],
      },
      wtList: [],
      wtList2: [],
      wzList: [],
      wzList2: [],
      zyList: [],
      zyList2: [],
      modelChooseListOpen: false,
      ModelList: [],
      groupType: [],
      FormData: {},
      selectNode: null,
      zTeeObj: null,
    };
  },
  //   模型初始化时调用方法请求接口
  created() {
    this.getData();
  },
  methods: {
    showAll() {
      this.fid = "null";
      this.bb();
    },
    //初始化ztree
    init() {
      var _this = this;

      var setting = {
        view: {
          selectedMulti: false,
        },
        check: {
          enable: true,
        },
        data: {
          key: {
            name: "pftr02",
          },
          simpleData: {
            enable: true,
            idKey: "pftr01",
            pIdKey: "pftr03",
          },
        },
        callback: {
          onCheck: onCheck,
          onClick: onclick,
          onRightClick: OnRightClick,
        },
      };
      // 在ztree上的右击事件
      function OnRightClick(event, treeId, treeNode) {
        _this.selectNode = treeNode;
        if (treeNode == null) {
          showRMenu("root", event.clientX, event.clientY);
        } else {
          _this.aaa.gid = treeNode.pftr01;
          showRMenu("node", event.clientX, event.clientY);
        }
      }
      //鼠标按下事件
      function onBodyMouseDown(event) {
        if (
          !(
            event.target.id == "dataListRemenu" ||
            $(event.target).parents("#dataListRemenu").length > 0
          )
        ) {
          $("#dataListRemenu").css({ visibility: "hidden" });
        }
      }
      //显示右键菜单
      function showRMenu(type, x, y) {
        if (type != "root") {
          $("#dataListRemenu").show();
          $("#addDataList").show();
          $("#dataListRemenu").css({
            top: y + "px",
            left: x + "px",
            visibility: "visible",
          }); //设置右键菜单的位置、可见
          $("body").bind("mousedown", onBodyMouseDown);
        }
      }

      $("#dataListRemenu ul li")
        .unbind()
        .bind("click", function () {
          $("#dataListRemenu").css({
            visibility: "hidden",
          });
          var type = $(this).attr("id");
          if (type == "addDataList") {
            _this.dialogVisible = true;
          }
        });

      this.zTeeObj = $.fn.zTree.init(
        $("#ProjectFileTree"),
        setting,
        this.TreeData
      );
      this.zTeeObj.checkAllNodes(true);

      var checkedNodes = this.zTeeObj.getCheckedNodes();
      _this.fid = "";
      var _split = "";
      checkedNodes.forEach((element) => {
        _this.fid += _split + element.pftr01;
        _split = ",";
      });
      _this.bb();
      // 选中状态
      function onCheck() {
        var checkedNodes = _this.zTeeObj.getCheckedNodes();
        _this.fid = "";
        var _split = "";
        checkedNodes.forEach((element) => {
          _this.fid += _split + element.pftr01;
          _split = ",";
        });
        _this.bb();
      }
      //点击事件
      function onclick(event, treeId, treeNode) {
        _this.fid = treeNode.pftr01;
        _this.bb();
      }
    },
    deleteGetModelSelectList2Item(data) {
      this.TypeData.splice(data, 1);
      // console.log(this.TypeData);
    },
    TypehandleClick(data) {
      this.TypeName = data;
      this.aa();
    },
    handleSelectionChange(val) {
      // console.log(val);
      val.forEach((item) => {
        this.TypeData.push(item);
      });
      function deteleObject(obj) {
        var uniques = [];
        var stringify = {};
        for (var i = 0; i < obj.length; i++) {
          var keys = Object.keys(obj[i]);
          keys.sort(function (a, b) {
            return Number(a) - Number(b);
          });
          var str = "";
          for (var j = 0; j < keys.length; j++) {
            str += JSON.stringify(keys[j]);
            str += JSON.stringify(obj[i][keys[j]]);
          }
          if (!stringify.hasOwnProperty(str)) {
            uniques.push(obj[i]);
            stringify[str] = true;
          }
        }
        uniques = uniques;
        return uniques;
      }
      let aa = deteleObject(this.TypeData);
      this.TypeData = aa;

      // console.log(this.TypeData);

      this.GetModelSelectList2.push(...val);
      var result = [];
      var obj = {};
      this.GetModelSelectList2.forEach((item) => {
        if (!obj[item.mosl01]) {
          result.push(item);
          obj[item.mosl01] = true;
        }
      });
      this.GetModelSelectList2 = result;
    },
    barCodeInit(item) {
      $("#codeShow").empty();
      var qrcode = new QRCode("codeShow", {
        text: item.prfl07,
        width: 256,
        height: 256,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
      window.open(item.prfl07);
    },
    // 查看模型
    viewModel(row) {
      let params = {
        id: row.id,
        type: row.type,
      };
      GetSelectOrView(params).then((res) => {
        let type = "modelSelect";
        if (res.Data.type == 3) {
          type = "viewpoint";
        }
        let params = `modelId=${res.Data.modelId}^@^type=${type}^@^state=${res.Data.state}^@^id=${res.Data.id}`;
        params = Base64.encode(params);
        let url = `#/viewModel?Code=${params}`;
        window.open(url);
      });
    },
    // 删除施工交底
    DelProjectWork(row) {
      this.$confirm("是否继续撤销该施工交底?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            sgid: row.work01,
          };
          DelProjectWork(params).then((res) => {
            if (res.Code > 0) {
              this.$message({
                type: "success",
                message: "撤销成功",
              });
              this.getData();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消撤销",
          });
        });
    },
    handleNodeClick(data) {
      this.aaa.gid = data.ID;
      this.isClick = true;
      this.fid = data.ID;
      this.bb();
    },
    delectUser(index) {
      this.multipleSelection3.splice(index, 1);
      this.$message({
        type: "success",
        message: "删除成功",
      });
    },
    dialogVisible1OPen() {
      this.dialogVisible1 = true;
      let params = {
        searchword: this.selectName,
        fid: 0,
        xid: localStorage.getItem("xid"),
      };
      GetFileWhitOutUserList({ params }).then((res) => {
        //(res);
        this.tableData3 = res.Data.list;
      });
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    handleSuccess(response, file, fileList) {
      if (response.Code > 0) {
        this.$message({
          type: "success",
          message: "上传成功",
        });
        this.dialogVisible = false;
        this.bb();
      }
    },
    handleBefore(file) {
      // debugger;
      let fd = new FormData();
      this.aaa.type = this.radio;
      let userID = [];
      this.multipleSelection3.forEach((ele) => {
        userID.push(ele.user01);
      });
      this.aaa.Uids = userID.join(",");
      fd.append("file", file);
      fd.append("model", this.aaa);
    },
    handlePreview(file) {
      //(file);
    },
    handleRemove(file, fileList) {
      //(file, fileList);
    },
    // 新增
    dialogVisibleOpen() {
      if (this.isClick == false) {
        this.$message({
          type: "warning",
          message: "请先选择",
        });
      } else {
        this.dialogVisible = true;
      }
    },
    // 删除安全交底
    DelProjectSafe(row) {
      this.$confirm("是否继续撤销该安全交底?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            aqid: row.pjsf01,
          };
          DelProjectSafe(params).then((res) => {
            if (res.Code > 0) {
              this.$message({
                type: "success",
                message: "撤销成功",
              });
              this.getData();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消撤销",
          });
        });
    },
    HandeApprovalOpen(row) {
      //(row);
      this.$prompt("审批内容", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          let params = {
            content: value,
            uid: localStorage.getItem("id"),
            xid: localStorage.getItem("xid"),
            aqid: row.pjsf01,
            type: 3,
          };
          HandelSafe({ ...params }).then((res) => {
            if (res.Code == 1) {
              this.$message({
                type: "success",
                message: "审批成功",
              });
              this.getData();
            }
            //(res);
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    seeListInfo(row) {
      this.seeListInfoOpen = true;
      //(row);
      this.FormData = row;
      let params = {
        aqid: row.pjsf01,
      };
      GetProjectSafeInfo({ params }).then((res) => {
        this.FormData = res.Data.info;
        this.FormData.pjsf10 = this.FormData.pjsf10.split("/");
        this.FormData.pjsf11 = this.FormData.pjsf11.split("/");
        this.FormData.pjsf12 = this.FormData.pjsf12.split("/");
        this.modelList = res.Data.modelList;
        this.fileList = res.Data.fileList;
        this.auList = res.Data.au;
        this.auList.forEach((ele) => {
          if (!this.groupType.includes(ele.GroupType)) {
            this.groupType.push(ele.GroupType);
          }
        });
        this.ccList = res.Data.cc;
      });
    },
    pushModelIds() {
      this.ruleForm.FileIds = [];
      this.GetFilesLinksList2.forEach((ele) => {
        this.ruleForm.FileIds.push(ele.prfl01);
      });
    },
    deleteGetFilesLinksList2Item(data) {
      this.GetFilesLinksList2.splice(data, 1);
      this.pushModelIds();
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
          this.multipleSelection = [];
          this.multipleSelection2 = [];
        })
        .catch((_) => {});
    },
    associatedDataOpen() {
      this.associatedData = true;
      let params = {
        xid: localStorage.getItem("xid"),
      };
      GetProjectFileZTree({ params }).then((res) => {
        this.TreeData = res.Data;
        this.init();
        // if (res.Data.length !== 0) {
        //   this.bb();
        // }
      });
    },
    bb() {
      let params = {
        fid: this.fid,
        xid: localStorage.getItem("xid"),
        seachword: this.query3,
        uid: localStorage.getItem("id"),
      };
      GetFilesLinks({ params }).then((res) => {
        this.GetFilesLinksList = res.Data;
      });
    },
    handleNodeClick(data) {
      this.fid = data.ID;
      this.isClick = true;
      this.fid = data.ID;
      this.bb();
      //(data);
    },
    deletemultipleSelection2(data) {
      //(data);
      this.GetFilesLinksList2.splice(data, 1);
      this.pushModelIds();
    },
    modelChooseList() {
      this.modelChooseListOpen = true;
      let params = {
        xid: localStorage.getItem("xid"),
        pid: this.pid,
      };
      GetWorkPlaneTree2(params).then((res) => {
        this.options = res.Data;
        this.options.forEach((item) => {
          this.judge(item);
        });
        this.init2();
      });
    },

    init2() {
      var _this = this;
      var setting = {
        view: {
          selectedMulti: false,
        },
        check: {
          enable: false,
        },
        data: {
          key: {
            name: "label",
          },
          simpleData: {
            enable: true,
            idKey: "ID",
            pIdKey: "ParentId",
          },
        },
        edit: {
          enable: true,
          showRemoveBtn: false,
          showRenameBtn: false,
          drag: {
            isMove: true,
            inner: true,
            prev: false,
            next: true,
          },
        },
        callback: {
          onClick: onclick,
        },
      };
      var objs = $.fn.zTree.init($("#WorkPlaneTree"), setting, this.options);
      if (objs != null) {
        if (localStorage.treeNid) {
          var currentNode = objs.getNodeByParam("ID", localStorage.treeNid);
          var name = currentNode.tId + "_a";
          $("#" + name).click();
        } else {
          $("#WorkPlaneTree_1_a").click();
        }
      }
      function onclick(event, treeId, treeNode) {
        if (treeNode.wopl07 == 1) {
          let params = {
            id: treeNode.ID,
          };
          FindWorkPlaneModel(params).then((res) => {
            if (res.Data == null) {
              _this.$message({
                type: "warning",
                message: this.$t('工单任务.此节点未绑定模型或选择集'),
              });
              return false;
            }
            let data = res.Data;
            _this.mid = data.modelId;
            let params = {
              seachword: _this.query2,
              mid: data.modelId,
              type: _this.TypeName,
              uid: localStorage.getItem("id"),
            };
            GetModelSelectOrViewPoint(params).then((res) => {
              _this.GetModelSelectList = res.Data;
            });
          });
        } else {
          _this.mid = -1;
          _this.GetModelSelectList = [];
          _this.$message({
            type: "warning",
            message: "只可选择单模",
          });
        }
      }
    },
    // 判断类型
    judge(item) {
      if (item.wopl07 == 1) {
        return (item.iconSkin = "pIcon01");
      } else if (item.wopl07 == 2) {
        return (item.iconSkin = "pIcon02");
      } else if (item.wopl07 == 3) {
        return (item.iconSkin = "pIcon03");
      } else {
        return (item.iconSkin = "pIcon04");
      }
    },

    aa() {
      let params = {
        searchword: this.query2,
        mid: this.mid,
        type: this.TypeName,
        uid: localStorage.getItem("id"),
      };
      GetModelSelectOrViewPoint(params).then((res) => {
        this.GetModelSelectList = res.Data;
      });
    },
    modelChooseListClose() {
      this.modelChooseListOpen = false;
      this.multipleSelection = [];
    },
    associatedDataClose() {
      this.associatedData = false;
      this.multipleSelection2 = [];
    },
    // 这里是切换模型
    handleClick(data) {
      //(data);
      // this.GetModelSelectList2 = this.unique(this.GetModelSelectList2);
      this.mid = data;
      this.aa();
    },
    addDialogFormVisibleOpen() {
      this.addDialogFormVisible = true;
      let params = {
        xid: localStorage.getItem("xid"),
        type: 3,
      };
      GetLablesetListOpen({ params }).then((res) => {
        this.wtList = res.Data.wt;
        this.wzList = res.Data.wz;
        this.zyList = res.Data.zy;
      });
    },
    // 这里是新建确定
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.pjsf10 = this.ruleForm.pjsf10.join("/");
          this.ruleForm.pjsf11 = this.ruleForm.pjsf11.join("/");
          this.ruleForm.pjsf12 = this.ruleForm.pjsf12.join("/");
          this.ruleForm.ModelSelectIds = this.TypeData;
          let model = JSON.stringify(this.ruleForm);
          AddProjectSafe({ model }).then((res) => {
            res.Code > 0
              ? this.$message.success("提交成功")
              : this.$message.error("提交失败");
            this.getData();
          });
          this.addDialogFormVisible = false;
        } else {
          this.$message({
            type: "warning",
            message: "表单输入有误",
          });
          return false;
        }
      });
    },
    // 删除用户
    showDeleteDialog(row) {
      //(row);
      let qid = localStorage.getItem("pid");
      let uid = row.id;
      this.$confirm("此操作将永久删除该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        RemoveCorporateGovernanceUser({ qid, uid }).then((res) => {
          if (res.Code == 1) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getData();
          } else {
            this.$message({
              message: "删除失败",
              type: "warning",
            });
          }
        });
      });
    },
    // 这里获取所有数据
    getData() {
      this.loading = true;
      let params = {
        xid: localStorage.getItem("xid"),
        seachword: this.query,
        pageIndex: this.pagenum,
        pageSize: this.pagesize,
        uid: localStorage.getItem("id"),
      };
      GetProjectSafeList({ params }).then((res) => {
        //(res, "res");
        this.total = res.Data.total;
        this.userList = res.Data.list;
        this.loading = false;
      });
    },
    //显示编辑用户对话框
    seeDialogFormVisible(row) {
      this.seeDialogFormVisible1 = true;
      let params = {
        id: row.id,
      };
      GetUserInfo({ params }).then((res) => {
        //(res);
        this.addForm = res.Data;
        // this.getData();
      });
      params = {
        pid: localStorage.getItem("pid"),
        uid: row.id,
        pageIndex: 1,
        pageSize: 10,
      };
      GetProjectList({ params }).then((res) => {
        //(res, "pid");
        this.userList2 = res.Data.list;
        this.obligation = res.Data;
        // this.getData();
      });
    },
    unique(arr, type) {
      if (type == "model") {
        for (var i = 0; i < arr.length; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].mosl01 == arr[j].mosl01) {
              //第一个等同于第二个，splice方法删除第二个
              arr.splice(j, 1);
              j--;
            }
          }
        }
      } else if (type == "file") {
        for (var i = 0; i < arr.length; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].prfl01 == arr[j].prfl01) {
              //第一个等同于第二个，splice方法删除第二个
              arr.splice(j, 1);
              j--;
            }
          }
        }
      }
      return arr;
    },
    handleSelectionChange2(val) {
      this.multipleSelection2 = val;
      this.GetFilesLinksList2.push(...val);
      this.GetFilesLinksList2 = this.unique(this.GetFilesLinksList2, "file");
      this.pushModelIds();
    },
    handleSelectionChange3(val) {
      this.multipleSelection3 = val;
    },
    handleSizeChange(val) {
      //   //(`每页 ${val} 条`)
      this.pagesize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      //   //(`当前页: ${val}`)
      // //("当前页码"+this.pagesize)
      this.pagenum = val;
      this.getData();
    },
    Exports(row) {
      let params = {
        aqid: row.pjsf01,
      };
      GetProjectSafeInfo({ params }).then((res) => {
        this.designForm = res.Data.info;
        this.designForm.pjsf10 = this.designForm.pjsf10.split("/");
        this.designForm.pjsf11 = this.designForm.pjsf11.split("/");
        this.designForm.pjsf12 = this.designForm.pjsf12.split("/");
        this.modelList = res.Data.modelList;
        this.fileList = res.Data.fileList;
        this.auList = res.Data.au;
        this.auList.forEach((ele) => {
          if (!this.groupType.includes(ele.GroupType)) {
            this.groupType.push(ele.GroupType);
          }
        });
        this.ccList = res.Data.cc;
        setTimeout(() => {
          $("#pdfDom").show();
          this.getPdf("安全交底");
          // 另一种方法
          // tableExport("table2", "文件名称", "pdf");
          $("#pdfDom").hide();
        }, 100);
      });
    },
  },
};
</script>
<style lang="less" scoped>
div#dataListRemenu {
  position: fixed;
  visibility: hidden;
  top: 0;
  width: 60px;
  background-color: #35a5db;
  padding: 4px;
  border-radius: 3px;
  overflow: auto;
  border: 1px solid #eee;
}

div#dataListRemenu ul {
  margin: 0px;
  padding: 0px;
}

div#dataListRemenu ul li {
  font-size: 12px;
  line-height: 20px;
  margin: 0px;
  padding: 0px;
  cursor: pointer;
  list-style: none outside none; //取消样式
  background-color: rgba(255, 255, 255, 0);
  padding-left: 3px;
  margin: 1px auto;
  color: white;
  border-radius: 3px;
  letter-spacing: 1px;
}

div#dataListRemenu ul li:hover {
  background: #eee;
  color: #000000;
}
.tableContent {
  width: 90%;
  font-size: 32px;
  overflow: hidden;
  margin: 0 auto;
  td,
  th {
    padding: 20px;
  }
}
#pdfDom {
  display: none;
  // padding: 40px;
  overflow: hidden;
  height: 100%;
  margin: 0 auto;
}

.designCoordination {
  // padding: 20px
}
/deep/ .upload-demo ul {
  width: 100%;
  margin-left: 10px;
  margin-bottom: 10px;
}
.user .margin-20 {
  margin: 20px 0;
}
.user .search-input {
  width: 300px;
}
.user .page {
  padding: 5px 0;
  background-color: #d3dce6;
}
.user {
  .btnArr {
    margin-top: 10px;
  }
}

.yq-col:nth-child(1) {
  overflow: hidden;
  margin: 0 0 0 150px;
  span {
    position: relative;
    bottom: 10px;
    left: 10px;
  }
}
.yq-col:nth-child(2) {
  overflow: hidden;
  margin: 0 0 0 0px;
  span {
    position: relative;
    bottom: 10px;
    left: 10px;
  }
}
.yq-col:nth-child(3) {
  overflow: hidden;
  margin: 0 0 0 0px;
  span {
    position: relative;
    bottom: 10px;
    left: 10px;
  }
}
.yq-col:nth-child(4) {
  overflow: hidden;
  margin: 0 0 0 0px;
  span {
    position: relative;
    bottom: 10px;
    left: 10px;
  }
}
.user-loading {
  display: flex;
  margin: 10px 0;
  p {
    margin: 8px 0 0 10px;
    span {
      color: #007acc;
    }
  }
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
[data-v-7ba5bd90] .el-dialog__body .el-row {
  padding: 0px;
}
#ProjectFileTree {
  height: 500px;
}
.zTreeDiv {
  overflow: auto;
}
.ztree li span {
  line-height: 21px;
  margin-right: 2px;
}
</style>
